import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  password: {
    required,
    minLength: minLength(3)
  },

  password_confirmation: {
    required,
    minLength: minLength(3),
    sameAsPassword: sameAs('password')
  }
}